import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { StatusLabel } from "@shared-features/enums/status-label.enum";

export class ShipmentStatusLabel extends Model {
  @Expose()
  id: number;

  @Expose()
  createdAt: number;

  @Expose()
  color: string;

  @Expose()
  icon: string;

  @Expose()
  label: StatusLabel;

  @Expose()
  updatedAt: number;
}
